export default {
  MuiCssBaseline: {
    '@global': {
      html: {
        backgroundColor: '#ffffff',
      },
      body: {
        backgroundColor: '#ffffff',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/MuiCssBaseline.js